"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const malty_atoms_icon_wrapper_1 = require("@carlsberggroup/malty.atoms.icon-wrapper");
const react_1 = __importDefault(require("react"));
const Badge = (props) => (0, malty_atoms_icon_wrapper_1.IconWrapper)(props, react_1.default.createElement("g", { fillRule: "evenodd" },
    react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    react_1.default.createElement("circle", { cx: 12.5, cy: 12.5, fill: "#4b87c5", r: 10.5 }),
    react_1.default.createElement("text", { fill: "#fff", fontFamily: "Montserrat-Bold, Montserrat", fontSize: 10, fontWeight: "bold", letterSpacing: 0.046 },
        react_1.default.createElement("tspan", { x: 9.177, y: 16 }, "8"))));
exports.default = Badge;
//# sourceMappingURL=index.js.map